import {useEffect} from "react";
import {Keyboard} from "@capacitor/keyboard";
import {isPlatform} from "@ionic/react";

export const useAutoScrollInputs = (formLoading: boolean) => {
    useEffect(() => {
        if (formLoading) return;

        const formElement = document.querySelector("form");

        if (formElement) {
            formElement.addEventListener("focusin", handleFocus as EventListener);
        }

        Keyboard.addListener("keyboardWillShow", handleKeyboardShow);
        Keyboard.addListener("keyboardWillHide", handleKeyboardHide);

        return () => {
            if (formElement) {
                formElement.removeEventListener("focusin", handleFocus as EventListener);
            }

            Keyboard.removeAllListeners();
        };
    }, [formLoading]);

    const handleFocus = (event: FocusEvent) => {
        if (isPlatform('ios')) {
            const scrollableContainer = findFirstScrollableContainerAboveForm();
            if (!scrollableContainer) {
                return;
            }

            const focusedInputRect = (event.target as HTMLElement).getBoundingClientRect();
            const scrollableContainerRect = scrollableContainer.getBoundingClientRect();

            const offset = 30;
            const distance = focusedInputRect.top - scrollableContainerRect.top - offset;

            return setTimeout(() => {
                scrollableContainer.scrollBy({
                    top: distance,
                    behavior: "smooth",
                });
            }, 650);
        }

        const target = event.target as HTMLElement;

        setTimeout(() => {
            target?.scrollIntoView({behavior: "smooth", block: "center"});
        }, 300);
    };

    const findFirstScrollableContainerAboveForm = (): HTMLElement | null => {
        const form = document.querySelector("form");
        if (!form) return null;

        let parent = form.parentElement;

        while (parent) {
            const style = getComputedStyle(parent);
            const overflowY = style.overflowY;

            const isScrollable = (overflowY === "auto" || overflowY === "scroll") && parent.scrollHeight > parent.clientHeight;
            if (isScrollable) {
                return parent;
            }

            parent = parent.parentElement;
        }

        return null;
    }

    const handleKeyboardShow = (info: any) => {
        document.body.style.paddingBottom = `${info.keyboardHeight}px`;
    };

    const handleKeyboardHide = () => {
        document.body.style.paddingBottom = "0px";
    };
};